import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import styles from './style.module.scss'

/*
 * Umschalter zwischen Zeilen und Kachelraster — nur Sinnbilder.
 *
 * Beschriftungen wären hier drei Wörter für etwas, das man an der Form
 * sofort sieht; sie stehen deshalb nur als Kurzhinweis und für
 * Vorlesewerkzeuge dahinter (`title` + `aria-label`). Welche Ansicht gilt,
 * sagt `aria-pressed` — nicht allein die Farbe.
 *
 * Die Sinnbilder sind hier gezeichnet statt aus der Sammlung geholt: Es sind
 * zwei Striche-und-Kästchen-Formen, die es dort nicht gibt, und sie erben so
 * die Schriftfarbe des Knopfs (`currentColor`).
 */
const ICON_SIZE = 18

const RowsIcon = () => (
	<svg
		className={styles.icon}
		viewBox="0 0 18 18"
		width={ICON_SIZE}
		height={ICON_SIZE}
		aria-hidden="true"
		focusable="false"
	>
		<g fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
			<path d="M2 4h14M2 9h14M2 14h14" />
		</g>
	</svg>
)

const TilesIcon = () => (
	<svg
		className={styles.icon}
		viewBox="0 0 18 18"
		width={ICON_SIZE}
		height={ICON_SIZE}
		aria-hidden="true"
		focusable="false"
	>
		<g fill="none" stroke="currentColor" strokeWidth="1.6">
			<rect x="2" y="2" width="6" height="6" rx="1.5" />
			<rect x="10" y="2" width="6" height="6" rx="1.5" />
			<rect x="2" y="10" width="6" height="6" rx="1.5" />
			<rect x="10" y="10" width="6" height="6" rx="1.5" />
		</g>
	</svg>
)

const VIEWS = [
	{ key: 'rows', label: 'viewRows', Icon: RowsIcon },
	{ key: 'tiles', label: 'viewTiles', Icon: TilesIcon }
]

export default function ViewToggle({ value, onChange, className }) {
	const { t } = useTranslation()

	return (
		<div className={clsx(styles.root, className)} role="group" aria-label={t('viewMode')}>
			{VIEWS.map(({ key, label, Icon }) => (
				<button
					key={key}
					type="button"
					className={clsx(styles.btn, value === key && styles.btnActive)}
					aria-pressed={value === key}
					aria-label={t(label)}
					title={t(label)}
					onClick={() => onChange(key)}
				>
					<Icon />
				</button>
			))}
		</div>
	)
}

ViewToggle.propTypes = {
	value: PropTypes.oneOf(['rows', 'tiles']).isRequired,
	onChange: PropTypes.func.isRequired,
	className: PropTypes.string
}
